import { useMemo, useState } from 'react';
import { Label } from '@/components/ui/label';
import { useCompanies } from '@/lib/adminApi';
import { CompanyAgreementsPanel } from './CompanyAgreementsPanel';

/**
 * AgreementsPage — /admin/agreements (AGR-01..04 + SET-05).
 *
 * Company picker → CompanyAgreementsPanel (active card + history + dialog).
 * As of 2026-06-11 this page is off the sidebar menu — agreements are managed
 * from the company profile (CompanyDetailPage) — but the route is kept for
 * deep links and as the home of the cross-company picker workflow.
 */
export default function AgreementsPage() {
  const { data: companiesData, isLoading: companiesLoading } = useCompanies();
  const [companyId, setCompanyId] = useState<string>('');

  const companies = useMemo(() => companiesData?.companies ?? [], [companiesData]);

  return (
    <div className="max-w-6xl mx-auto px-6 py-8">
      <header className="mb-6">
        <h2 className="text-2xl font-semibold leading-[1.3]">Agreements</h2>
        <p className="text-sm text-muted-foreground mt-1">
          One active Agreement per Company. History is read-only below.
        </p>
      </header>

      <div className="mb-8 max-w-md space-y-2">
        <Label htmlFor="company-picker">Company</Label>
        <select
          id="company-picker"
          className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm"
          value={companyId}
          onChange={(e) => setCompanyId(e.target.value)}
          disabled={companiesLoading}
        >
          <option value="">Select a company…</option>
          {companies.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
      </div>

      {companyId && <CompanyAgreementsPanel companyId={companyId} />}
    </div>
  );
}
